<template>
	<div>
		<el-button size="mini" :type="b.type" :icon="b.icon" @click.native="handle(b)" v-for="(b,bindex) in handlerlist" :key="bindex" style="margin-left:5px;margin-top: 5px;">{{b.title}}</el-button>
	</div>
</template>

<script>
export default {
	props: {
		l_id: {
			type: String,
			default:''
		}
	},
	data() {
		return {
			handlerlist:[],
			handlerbtn_lang:{}
		};
	},
	mounted() {
		this.init();
	},
	methods: {
		init(){
			//debugger
			var that=this;
			this.$public.GetLanguageByMode('handlerbtn',this).then(res=>{
				//debugger
				if(res.state=='1')
					that.handlerbtn_lang=that.$lang.label.handlerbtn;
				that.GetButtons();
			});
		},
		GetButtons(){
			var that=this;
			//debugger
			this.$apipost.get.GetButtons({l_id:this.l_id}).then(res => {
				//debugger
				if(res!=''){
					if(res.linklist!=undefined){
						res.linklist.forEach(e=>{
							if(that.handlerbtn_lang[e.title]!=undefined)
								e.title=that.handlerbtn_lang[e.title];
							if(that.handlerbtn_lang[e.l_tabname]!=undefined)
								e.l_tabname=that.handlerbtn_lang[e.l_tabname];
						});
						that.handlerlist=res.linklist;
					}
				}
				this.$emit('sethandelshow',{type:'button',show:that.handlerlist.length>0});
			}).catch(e=>{
				
			});
		},
		//操作栏按钮单击事件
		handle(b) {
			this.$emit('buttoncb', b);
		}
	}
};
</script>

<style>
</style>
